if (!customElements.get('product-details-tabs')) {
  customElements.define(
    'product-details-tabs',
    class ProductDetailsTabs extends HTMLElement {
      connectedCallback() {
        this.tabs = [...this.querySelectorAll('[data-product-details-tab]')];
        this.panels = [...this.querySelectorAll('[data-product-details-panel]')];
        if (!this.tabs.length) return;

        this.tabs.forEach((tab) => {
          tab.addEventListener('click', () => this.activateTab(tab));
          tab.addEventListener('keydown', (e) => this.onKeydown(e, tab));
        });
      }

      activateTab(tab) {
        const panelId = tab.getAttribute('aria-controls');
        if (!panelId) return;

        this.tabs.forEach((t) => {
          const selected = t === tab;
          t.classList.toggle('is-active', selected);
          t.setAttribute('aria-selected', selected ? 'true' : 'false');
          t.tabIndex = selected ? 0 : -1;
        });

        this.panels.forEach((panel) => {
          const show = panel.id === panelId;
          panel.hidden = !show;
        });
      }

      onKeydown(event, tab) {
        const idx = this.tabs.indexOf(tab);
        if (idx < 0) return;

        let nextIdx = null;
        if (event.key === 'ArrowRight') nextIdx = (idx + 1) % this.tabs.length;
        if (event.key === 'ArrowLeft') nextIdx = (idx - 1 + this.tabs.length) % this.tabs.length;
        if (event.key === 'Home') nextIdx = 0;
        if (event.key === 'End') nextIdx = this.tabs.length - 1;

        if (nextIdx == null) return;
        event.preventDefault();
        this.tabs[nextIdx].focus();
        this.activateTab(this.tabs[nextIdx]);
      }
    }
  );
}
